import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'underscore';
import Modal from 'react-responsive-modal';

import Logger, {LOG_LEVELS} from '../../utils/logger';
import { SLoader } from '@avalara/skylab-sdk/react';

const log = new Logger('BUSY_SPINNER', LOG_LEVELS.ERROR);
class LoadingSpinner extends Component {
  render() {
    log.debug('render(): ', this.props);

    return (
      <Modal little
             open={this.props.busy}
             closeOnOverlayClick={false}
             closeOnEsc={false}
             showCloseIcon={false}
             onClose={()=>{}}
            classNames={{
              modal: "no-modal-bg"
            }}
      >
        <SLoader loading />
      </Modal>
    );
  }

}

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
  log.debug('mapStateToProps: ', state);
  return {

  };
}



// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps)(LoadingSpinner);